import { Workflow } from '@/models/workflow/workflow'
import { WorkflowType } from '@/types/workflow'
import { WorkflowInstanceDto } from '@/api/origin-workflow-svc'

export class OorWorkflow extends Workflow {
  constructor(data: WorkflowInstanceDto) {
    super(data, WorkflowType.OOR_VLEI_PREREQ)
  }
}
